import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

/**
 * Le Board est la page d'entrée : la liste s'obtient par ses filtres rapides. `board` reste une
 * route nommée pour les liens profonds et les signets.
 */
export const SafetyOccurrenceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--occurrences']}>
    <Route index element={<Index />} />
    <Route path='board' element={<Index />} />
    <Route path=':occurrenceId/*' element={<Detail />} />
  </SubRouter>
))
